// src/utils/nodeUrls.js
export const nodeUrls = [
  "https://mainnet-0.ndau.tech:3030/",
  "https://mainnet-1.ndau.tech:3030/",
  "https://mainnet-2.ndau.tech:3030/",
  "https://mainnet-3.ndau.tech:3030/",
  "https://mainnet-4.ndau.tech:3030/",
//  "http://3.17.202.109:3030/",
//  "http://44.199.144.40:3030/",
];
